import {DataFetcherSideEffects} from '@aboutyou/data-fetcher';
import {BasketToken} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/basket_token.types';
import {useBasketToken} from '@aboutyou/user';
import React, {useMemo} from 'react';

export const RegisterDataFetcherSideEffects: React.FC = () => {
  const {updateBasketToken} = useBasketToken();

  const sideEffects = useMemo(() => {
    return {
      queries: {
        onSuccess: (data: any) => {
          const basketToken: BasketToken | undefined =
            data?.basketToken || data?.sections?.basketToken;

          if (basketToken) {
            updateBasketToken(basketToken);
          }
        },
      },
      mutations: {
        onSuccess: (data: any) => {
          const basketToken: BasketToken | undefined =
            data?.basketToken || data?.sections?.basketToken;

          if (basketToken) {
            updateBasketToken(basketToken);
          }
        },
      },
    };
  }, [updateBasketToken]);

  return <DataFetcherSideEffects sideEffects={sideEffects} />;
};
